// extracted by mini-css-extract-plugin
export default {"container":"_6Q88FhMcGJ--VWMtliTSfw==","list":"xHXaFYdQEUufQhIzEXFcdA==","title":"j60pQ97ZeYF5QQjM1q1NpA==","list-item":"QIRBZWktWR6TAqK6QbmWEQ=="};